"use client";

import ThemeToggle from '@/components/ui/ThemeToggle';
import { usePathname } from 'next/navigation';

export default function FloatingThemeToggle() {
  const pathname = usePathname();
  const isDashboardRoute = pathname?.startsWith('/dashboard') || pathname?.startsWith('/admin');

  return (
    <div className={`fixed bottom-6 right-6 z-[60] ${isDashboardRoute ? 'hidden xl:block' : ''}`}>
      <div className="shadow-xl rounded-full p-1 bg-card/90 border border-border backdrop-blur-md focus-within:outline-none focus-within:ring-2 focus-within:ring-accent">
        <ThemeToggle />
      </div>
    </div>
  );
}
